import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { StudioTeaser } from "@/components/StudioTeaser";
import { FeaturedWorks } from "@/components/FeaturedWorks";
import { Testimonials } from "@/components/Testimonials";
import { ServicesStrip } from "@/components/ServicesStrip";
import { ConsultationCta } from "@/components/ConsultationCta";

export default function Home() {
    return (
        <div data-testid="page-home">
            <Hero />
            <Marquee />
            <StudioTeaser />
            <FeaturedWorks />
            <Testimonials />
            <ServicesStrip />
            <ConsultationCta />
        </div>
    );
}
